/**
 * Pure context object — no React components — so fast-refresh stays
 * happy when ThemeProvider re-mounts. Imported by both ThemeContext
 * (provider) and useTheme (consumer hook).
 *
 * UI-v2 Phase 0: added `brand` (BrandId) as the second, orthogonal
 * dimension alongside `effective` (light/dark). The brand dimension
 * drives `data-brand` on <html> for the white-label CSS seam.
 * Phase 0: const-defaulted to "certain"; not user-settable yet.
 */
import { createContext } from "react";
import type { EffectiveTheme, ThemePreference } from "@/lib/theme";
import type { BrandId } from "@/config/brand";

export interface ThemeContextValue {
  preference: ThemePreference;
  effective: EffectiveTheme;
  setPreference: (pref: ThemePreference) => void;
  /** The active brand id — drives [data-brand] CSS override blocks.
   *  Phase 0: always "certain"; extended for white-label in Phase 1+. */
  brand: BrandId;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
